import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export default function Loading() {
    return (
        <Grid item xs={12} order={{ xs: 2, md: 1 }} display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
            <Skeleton
                height={200}
                animation="wave"
                variant="rounded"
                sx={{ width: "100%" }}
            />
            <Skeleton
                height={200}
                animation="wave"
                variant="rounded"
                sx={{ width: "100%" }}
            />
        </Grid>
    );
};